{
  "addons.addonList": "قائمة الإضافات",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "أنشئ واحصل على مفتاح API الخاص بك من هذا الرابط",
  "addons.ambientWeatherDescription": "محطات Ambient Weather (WS-5000، WS-2000، WS-2902C،...)",
  "addons.apiKey": "مفتاح API",
  "addons.applicationKey": "مفتاح التطبيق",
  "addons.connect": "اتصال",
  "addons.davisApiSecret": "رمز API السري",
  "addons.davisApiV2Key": "مفتاح V2 API",
  "addons.davisDescription": "محطات Davis الجوية (Vantage Vue، Vantage Pro2،...)",
  "addons.davisRetrieveApiKey": "احصل على مفاتيح V2 API الخاصة بك من هذا الرابط",
  "addons.disconnect": "قطع الاتصال",
  "addons.ecowittCreateAndRetrieveKeys": "أنشئ واحصل على مفتاح API ومفتاح التطبيق من هذا الرابط",
  "addons.ecowittDescription": "توفر Ecowitt محطات طقس احترافية بتقنية الواي فاي، ومقاييس حرارة لاسلكية داخلية وخارجية، وأجهزة مراقبة الرطوبة، ومقاييس أمطار عالية الدقة، وأجهزة مراقبة جودة الهواء والمزيد.",
  "addons.helpLink": "كيفية ربط {provider}",
  "addons.myAcuriteAccountOnHold": "تم تعليق حسابك. يرجى إدخال كلمة المرور لإعادة الاتصال بحسابك",
  "addons.myAcuriteDescription": "AcuRite هي العلامة التجارية الأولى لمحطات الطقس في أمريكا الشمالية. كشركة رائدة في تقنية الوقت والحرارة والطقس، توفر لك AcuRite معلومات تفصيلية عن بيئتك الداخلية والخارجية لتخطيط يومك بثقة.",
  "addons.myAcuriteEnterCredentials": "أدخل بيانات اعتماد My AcuRite الخاصة بك لربط حساب My AcuRite بـ SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "استخدم منظم الحرارة Netatmo لتغيير درجة حرارة منزلك، من سريرك أو من الجانب الآخر من العالم.",
  "addons.netatmoThermostat": "منظم حرارة Netatmo",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "محطة الطقس الشخصية في منزلك",
  "addons.or": "أو",
  "addons.providerAccountDisconnected": "انتهت صلاحية الاتصال بخدمة الطقس الخاصة بك. يرجى إعادة الاتصال لاستئناف تحديثات البيانات.",
  "addons.reconnect": "إعادة الاتصال",
  "addons.weatherflowCreateToken": "أنشئ واحصل على الرمز المميز الخاص بك من هذا الرابط",
  "addons.weatherflowTempestDescription": "نظام Tempest للطقس مع مقياس رياح ومقياس أمطار مدمج",
  "addons.wundergroundApiKey": "مفتاح API",
  "addons.wundergroundDescription": "Weather Underground هو مجتمع عالمي من الأشخاص الذين يربطون البيانات من أجهزة استشعار البيئة مثل محطات الطقس وأجهزة مراقبة جودة الهواء حتى نتمكن من توفير البيانات الغنية والمحلية التي تحتاجها لتحقيق شغفك",
  "addons.wundergroundRetrieveApiKey": "احصل على مفتاح API الخاص بك من هذا الرابط",
  "addons.wundergroundRetrieveStationId": "احصل على معرف المحطة الخاص بك من هذا الرابط",
  "addons.wundergroundStationId": "معرف المحطة",
  "airQuality.airQuality": "جودة الهواء",
  "airQuality.airQualityIndex": "مؤشر جودة الهواء",
  "airQuality.aqiForecast": "توقعات جودة الهواء",
  "airQuality.co": "أول أكسيد الكربون",
  "airQuality.dailyForecast": "التوقعات اليومية",
  "airQuality.details": "التفاصيل",
  "airQuality.dominantPollutant": "الملوث السائد",
  "airQuality.good": "جيدة",
  "airQuality.goodDescription": "جودة الهواء مرضية، وتلوث الهواء يشكل خطراً ضئيلاً أو معدوماً",
  "airQuality.hazardous": "خطرة",
  "airQuality.hazardousDescription": "تنبيه صحي: قد يعاني أي شخص من آثار صحية أكثر خطورة",
  "airQuality.indoorAirQuality": "جودة الهواء الداخلي",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "معتدلة",
  "airQuality.moderateDescription": "جودة الهواء مقبولة؛ ومع ذلك، بالنسبة لبعض الملوثات قد يكون هناك قلق صحي معتدل لعدد قليل جداً من الأشخاص الذين لديهم حساسية غير عادية لتلوث الهواء.",
  "airQuality.no2": "ثاني أكسيد النيتروجين",
  "airQuality.o3": "الأوزون",
  "airQuality.pm10": "جسيمات بقطر 10 ميكرومتر أو أقل",
  "airQuality.pm25": "جسيمات بقطر 2.5 ميكرومتر أو أقل",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "غير صحية للفئات الحساسة",
  "airQuality.sensitiveUnhealthyDescription": "قد يعاني أفراد الفئات الحساسة من آثار صحية. من غير المرجح أن يتأثر عامة الناس.",
  "airQuality.so2": "ثاني أكسيد الكبريت",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "غير صحية",
  "airQuality.unhealthyDescription": "قد يبدأ الجميع في الشعور بآثار صحية؛ قد تعاني الفئات الحساسة من آثار صحية أكثر خطورة",
  "airQuality.veryUnhealthy": "غير صحية جداً",
  "airQuality.veryUnhealthyDezscription": "تحذيرات صحية من حالات الطوارئ. من المرجح أن يتأثر جميع السكان.",
  "alerts.addAlert": "إضافة تنبيه",
  "alerts.addCondition": "إضافة شرط",
  "alerts.alertAdded": "تمت إضافة التنبيه بنجاح",
  "alerts.alertAuthorizationNotice": "تعمل التنبيهات فقط إذا سمحت لـ SmartMixin بعرض الإشعارات",
  "alerts.alertDeleted": "تم حذف التنبيه بنجاح",
  "alerts.alertEdited": "تم تعديل التنبيه بنجاح",
  "alerts.alertName": "اسم التنبيه",
  "alerts.alertWhen": "أريد أن أتلقى تنبيهاً عندما:",
  "alerts.aqiGreaterThan": "مؤشر جودة الهواء أكبر من",
  "alerts.aqiGreaterThanThreshold": "مؤشر جودة الهواء أكبر من عتبة {value}{unit}",
  "alerts.aqiLessThan": "مؤشر جودة الهواء أقل من",
  "alerts.aqiLessThanThreshold": "مؤشر جودة الهواء أقل من عتبة {value}{unit}",
  "alerts.atLeastOneCondition": "تحتاج إلى إضافة شرط واحد على الأقل",
  "alerts.co2GreaterThan": "ثاني أكسيد الكربون أكبر من",
  "alerts.co2GreaterThanThreshold": "ثاني أكسيد الكربون أكبر من عتبة {value}{unit}",
  "alerts.co2LessThan": "ثاني أكسيد الكربون أقل من",
  "alerts.co2LessThanThreshold": "ثاني أكسيد الكربون أقل من عتبة {value}{unit}",
  "alerts.conditions": "الشروط",
  "alerts.createAlert": "إنشاء تنبيه",
  "alerts.dailyPrecipitationGreaterThan": "هطول الأمطار اليومي أكبر من",
  "alerts.dailyPrecipitationGreaterThanThreshold": "هطول الأمطار اليومي تجاوز عتبة {value}{unit}",
  "alerts.deleteAlert": "حذف التنبيه",
  "alerts.editAlert": "تعديل التنبيه",
  "alerts.editCondition": "تعديل الشرط",
  "alerts.gustSpeedGreaterThan": "سرعة الهبات أكبر من",
  "alerts.gustSpeedGreaterThanThreshold": "سرعة الهبات أكبر من عتبة {value}{unit}",
  "alerts.gustSpeedLessThan": "سرعة الهبات أقل من",
  "alerts.gustSpeedLessThanThreshold": "سرعة الهبات أقل من عتبة {value}{unit}",
  "alerts.heatIndexGreaterThan": "مؤشر الحرارة أكبر من",
  "alerts.heatIndexGreaterThanThreshold": "مؤشر الحرارة أكبر من عتبة {value}{unit}",
  "alerts.heatIndexLessThan": "مؤشر الحرارة أقل من",
  "alerts.heatIndexLessThanThreshold": "مؤشر الحرارة أقل من عتبة {value}{unit}",
  "alerts.humidexGreaterThan": "مؤشر الرطوبة أكبر من",
  "alerts.humidexGreaterThanThreshold": "مؤشر الرطوبة أكبر من عتبة {value}{unit}",
  "alerts.humidexLessThan": "مؤشر الرطوبة أقل من",
  "alerts.humidexLessThanThreshold": "مؤشر الرطوبة أقل من عتبة {value}{unit}",
  "alerts.humidityGreaterThan": "الرطوبة أكبر من",
  "alerts.humidityGreaterThanThreshold": "الرطوبة أكبر من عتبة {value}{unit}",
  "alerts.humidityLessThan": "الرطوبة أقل من",
  "alerts.humidityLessThanThreshold": "الرطوبة أقل من عتبة {value}{unit}",
  "alerts.inProgress": "قيد التنفيذ",
  "alerts.myAlerts": "تنبيهاتي",
  "alerts.noConfiguredAlert": "ليس لديك أي تنبيهات مُعدة بعد، ابدأ بإضافة واحد",
  "alerts.noiseGreaterThan": "الضوضاء أكبر من",
  "alerts.noiseGreaterThanThreshold": "الضوضاء أكبر من عتبة {value}{unit}",
  "alerts.noiseLessThan": "الضوضاء أقل من",
  "alerts.noiseLessThanThreshold": "الضوضاء أقل من عتبة {value}{unit}",
  "alerts.noteOnConditions": "ملاحظة: يتم تفعيل التنبيه عند تحقق جميع الشروط أدناه",
  "alerts.pm10GreaterThan": "PM 10 أكبر من",
  "alerts.pm10GreaterThanThreshold": "PM 10 أكبر من عتبة {value}{unit}",
  "alerts.pm10LessThan": "PM 10 أقل من",
  "alerts.pm10LessThanThreshold": "PM 10 أقل من عتبة {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 أكبر من",
  "alerts.pm1GreaterThanThreshold": "PM 1 أكبر من عتبة {value}{unit}",
  "alerts.pm1LessThan": "PM 1 أقل من",
  "alerts.pm1LessThanThreshold": "PM 1 أقل من عتبة {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 أكبر من",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 أكبر من عتبة {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 أقل من",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 أقل من عتبة {value}{unit}",
  "alerts.postStormSummary": "ملخص بعد العاصفة",
  "alerts.postStormSynopsisHelper": "ستتلقى إشعارًا ملخصًا بعد انتهاء كل عاصفة مطرية.",
  "alerts.postStormSynopsisSoleCondition": "لا يمكن دمج ملخص ما بعد العاصفة مع شروط أخرى.",
  "alerts.precipitationGreaterThan": "هطول الأمطار بالساعة أكبر من",
  "alerts.precipitationGreaterThanThreshold": "هطول الأمطار بالساعة تجاوز عتبة {value}{unit}",
  "alerts.pressureGreaterThan": "الضغط الجوي أكبر من",
  "alerts.pressureGreaterThanThreshold": "الضغط الجوي أكبر من عتبة {value}{unit}",
  "alerts.pressureLessThan": "الضغط الجوي أقل من",
  "alerts.pressureLessThanThreshold": "الضغط الجوي أقل من عتبة {value}{unit}",
  "alerts.rainRateGreaterThan": "معدل هطول المطر أكبر من",
  "alerts.rainRateGreaterThanThreshold": "معدل هطول المطر تجاوز عتبة {value}{unit}",
  "alerts.solarRadiationGreaterThan": "الإشعاع الشمسي أكبر من",
  "alerts.solarRadiationGreaterThanThreshold": "الإشعاع الشمسي أكبر من عتبة {value}{unit}",
  "alerts.solarRadiationLessThan": "الإشعاع الشمسي أقل من",
  "alerts.solarRadiationLessThanThreshold": "الإشعاع الشمسي أقل من عتبة {value}{unit}",
  "alerts.temperatureGreaterThan": "درجة الحرارة أكبر من",
  "alerts.temperatureGreaterThanThreshold": "درجة الحرارة أكبر من عتبة {value}{unit}",
  "alerts.temperatureLessThan": "درجة الحرارة أقل من",
  "alerts.temperatureLessThanThreshold": "درجة الحرارة أقل من عتبة {value}{unit}",
  "alerts.thswGreaterThan": "THSW أكبر من",
  "alerts.thswGreaterThanThreshold": "THSW أكبر من عتبة {value}{unit}",
  "alerts.thswLessThan": "THSW أقل من",
  "alerts.thswLessThanThreshold": "THSW أقل من عتبة {value}{unit}",
  "alerts.thwGreaterThan": "THW أكبر من",
  "alerts.thwGreaterThanThreshold": "THW أكبر من عتبة {value}{unit}",
  "alerts.thwLessThan": "THW أقل من",
  "alerts.thwLessThanThreshold": "THW أقل من عتبة {value}{unit}",
  "alerts.uvGreaterThan": "مؤشر الأشعة فوق البنفسجية أكبر من",
  "alerts.uvGreaterThanThreshold": "مؤشر الأشعة فوق البنفسجية أكبر من عتبة {value}{unit}",
  "alerts.uvLessThan": "مؤشر الأشعة فوق البنفسجية أقل من",
  "alerts.uvLessThanThreshold": "مؤشر الأشعة فوق البنفسجية أقل من عتبة {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "الرؤية أكبر من عتبة {value}{unit}",
  "alerts.visibilityLessThanThreshold": "الرؤية أقل من عتبة {value}{unit}",
  "alerts.visiblityGreaterThan": "الرؤية أكبر من",
  "alerts.visiblityLessThan": "الرؤية أقل من",
  "alerts.whichMeasure": "ما القياس الذي تريد تلقي تنبيه بشأنه؟",
  "alerts.whichModule": "ما الوحدة التي تريد تلقي تنبيه بشأنها؟",
  "alerts.windChillGreaterThan": "برودة الرياح أكبر من",
  "alerts.windChillGreaterThanThreshold": "برودة الرياح أكبر من عتبة {value}{unit}",
  "alerts.windChillLessThan": "برودة الرياح أقل من",
  "alerts.windChillLessThanThreshold": "برودة الرياح أقل من عتبة {value}{unit}",
  "alerts.windSpeedGreaterThan": "سرعة الرياح أكبر من",
  "alerts.windSpeedGreaterThanThreshold": "سرعة الرياح أكبر من عتبة {value}{unit}",
  "alerts.windSpeedLessThan": "سرعة الرياح أقل من",
  "alerts.windSpeedLessThanThreshold": "سرعة الرياح أقل من عتبة {value}{unit}",
  "astral.astronomicalSunPhase": "{sunPhase} الفلكي",
  "astral.civilSunPhase": "{sunPhase} المدني",
  "astral.dawn": "الفجر",
  "astral.dusk": "الغسق",
  "astral.firstQuarter": "الربع الأول",
  "astral.fullMoon": "البدر",
  "astral.lastQuarter": "الربع الأخير",
  "astral.moon": "القمر",
  "astral.moonPhases": "أطوار القمر",
  "astral.moonrise": "شروق القمر",
  "astral.moonset": "غروب القمر",
  "astral.nauticalSunPhase": "{sunPhase} البحري",
  "astral.newMoon": "المحاق",
  "astral.noon": "الظهيرة",
  "astral.remainingDaylight": "ضوء النهار المتبقي",
  "astral.sunrise": "شروق الشمس",
  "astral.sunriseAndSunset": "شروق وغروب الشمس",
  "astral.sunriseAt": "شروق الشمس في {time}",
  "astral.sunset": "غروب الشمس",
  "astral.sunsetAt": "غروب الشمس في {time}",
  "astral.totalDaylight": "إجمالي ضوء النهار",
  "astral.waningCrescent": "الهلال المتناقص",
  "astral.waningGibbous": "الأحدب المتناقص",
  "astral.waxingCrescent": "الهلال المتزايد",
  "astral.waxingGibbous": "الأحدب المتزايد",
  "auth.alreadyHaveAccount": "هل لديك حساب بالفعل؟",
  "auth.authContainerTagline": "لوحة الطقس الشخصية الخاصة بك. قم بتوصيل محطاتك واحصل على البيانات في الوقت الفعلي في متناول يدك.",
  "auth.backToLogin": "العودة إلى تسجيل الدخول",
  "auth.catchPhrase": "منصة الذكاء الجوي",
  "auth.checkYourEmail": "تحقق من بريدك الإلكتروني",
  "auth.continueWithApple": "المتابعة مع Apple",
  "auth.continueWithFacebook": "المتابعة مع Facebook",
  "auth.continueWithGoogle": "المتابعة مع Google",
  "auth.email": "البريد الإلكتروني",
  "auth.emailRequiredLoginFacebook": "إذن البريد الإلكتروني مطلوب.",
  "auth.emailVerification": "التحقق من البريد الإلكتروني",
  "auth.emailVerificationFailure": "حدثت مشكلة في التحقق من بريدك الإلكتروني.",
  "auth.emailVerificationSuccess": "تم التحقق من بريدك الإلكتروني بنجاح.",
  "auth.firstName": "الاسم الأول",
  "auth.forgotPassword": "نسيت كلمة المرور؟",
  "auth.forgotPasswordSubtitle": "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
  "auth.lastName": "اسم العائلة",
  "auth.login": "تسجيل الدخول",
  "auth.loginSubtitle": "مرحباً بعودتك! الرجاء إدخال بياناتك.",
  "auth.loginToSmartMixinDescription": "أدخل بيانات اعتماد SmartMixin للوصول إلى حسابك.",
  "auth.logout": "تسجيل الخروج",
  "auth.logoutConfirmation": "هل أنت متأكد من رغبتك في تسجيل الخروج؟",
  "auth.noAccountYet": "ليس لديك حساب بعد؟",
  "auth.or": "أو",
  "auth.password": "كلمة المرور",
  "auth.passwordAgain": "كلمة المرور مرة أخرى",
  "auth.passwordReset": "إعادة تعيين كلمة المرور",
  "auth.passwordResetSuccess": "تم تحديث كلمة المرور بنجاح.",
  "auth.register": "إنشاء حساب",
  "auth.registerDescription": "أنشئ حساب SmartMixin مجاني لتوصيل محطاتك الجوية وتتبع بيانات الطقس والوصول إلى أدوات تحليل قوية.",
  "auth.registerSubtitle": "أنشئ حسابك للبدء.",
  "auth.registerSuccess": "تم التسجيل بنجاح! لقد أرسلنا لك رابط التحقق على {emailAddress} مع مزيد من التعليمات.",
  "auth.restorePassword": "استعادة كلمة المرور",
  "auth.restorePasswordSuccess": "لقد أرسلنا لك رابط إعادة تعيين كلمة المرور على {emailAddress} مع مزيد من التعليمات.",
  "auth.sendReset": "إرسال تعليمات إعادة التعيين",
  "auth.socialAccount": "أو استخدم حسابك",
  "auth.welcome": "مرحباً بك في SmartMixin",
  "auth.welcomeBack": "مرحباً بعودتك!",
  "calendar.april": "أبريل",
  "calendar.august": "أغسطس",
  "calendar.dateFormat": "تنسيق التاريخ",
  "calendar.day": "يوم",
  "calendar.december": "ديسمبر",
  "calendar.end": "النهاية",
  "calendar.february": "فبراير",
  "calendar.hours": "ساعات",
  "calendar.hoursShort": "س",
  "calendar.january": "يناير",
  "calendar.july": "يوليو",
  "calendar.june": "يونيو",
  "calendar.last24Hours": "آخر 24 ساعة",
  "calendar.last30Days": "آخر 30 يوماً",
  "calendar.last7Days": "آخر 7 أيام",
  "calendar.march": "مارس",
  "calendar.max": "الأقصى",
  "calendar.may": "مايو",
  "calendar.month": "شهر",
  "calendar.months": "أشهر",
  "calendar.november": "نوفمبر",
  "calendar.october": "أكتوبر",
  "calendar.oneDay": "يوم واحد",
  "calendar.oneHour": "ساعة واحدة",
  "calendar.oneMonth": "شهر واحد",
  "calendar.oneWeek": "أسبوع واحد",
  "calendar.previous24Hours": "الـ 24 ساعة السابقة",
  "calendar.previous30Days": "الـ 30 يوماً السابقة",
  "calendar.previous7Days": "الـ 7 أيام السابقة",
  "calendar.previousDay": "اليوم السابق",
  "calendar.previousMonth": "الشهر السابق",
  "calendar.previousWeek": "الأسبوع السابق",
  "calendar.previousYear": "السنة السابقة",
  "calendar.sameDayLastYear": "نفس اليوم من العام الماضي",
  "calendar.sameMonthLastYear": "نفس الشهر من العام الماضي",
  "calendar.selectADate": "اختر تاريخاً",
  "calendar.selectAggregation": "اختر القيمة المعروضة",
  "calendar.selectAMonth": "اختر شهراً",
  "calendar.selectAYear": "اختر سنة",
  "calendar.selectGranularity": "اختر دقة الفترة الزمنية",
  "calendar.selectTimescale": "اختر المقياس الزمني",
  "calendar.september": "سبتمبر",
  "calendar.sixHours": "6 ساعات",
  "calendar.start": "البداية",
  "calendar.thirtyMinutes": "30 دقيقة",
  "calendar.threeHours": "3 ساعات",
  "calendar.use24HourFormat": "استخدم تنسيق 24 ساعة",
  "calendar.week": "أسبوع",
  "calendar.year": "سنة",
  "calendar.yesterday": "أمس",
  "common.accountDeleted": "تم حذف حسابك بنجاح.",
  "common.accountOnHold": "انتهت صلاحية اتصال حسابك. يرجى إعادة الاتصال لاستئناف تحديثات البيانات.",
  "common.add": "إضافة",
  "common.addAStation": "إضافة محطة",
  "common.addToFavorites": "إضافة إلى المفضلة",
  "common.addYourOwnStation": "أضف محطتك الخاصة",
  "common.alreadyPremium": "لديك حساب مميز بالفعل!",
  "common.alsoAvailableOn": "متاح أيضاً على:",
  "common.altitude": "الارتفاع",
  "common.analysis": "التحليل",
  "common.aroundMe": "حولي",
  "common.articleCount": "{count, plural, zero {لا توجد مقالات} one {مقالة واحدة} two {مقالتان} few {# مقالات} many {# مقالة} other {# مقالة}}",
  "common.articleNotFound": "المقالة غير موجودة",
  "common.articleNotFoundDescription": "المقالة التي تبحث عنها غير موجودة.",
  "common.average": "المتوسط",
  "common.averageOverThePeriod": "المتوسط خلال الفترة",
  "common.away": "بعيد",
  "common.back": "رجوع",
  "common.backToHelpCenter": "العودة إلى مركز المساعدة",
  "common.backToHome": "العودة إلى الرئيسية",
  "common.bad": "سيئ",
  "common.batteryLevel": "مستوى البطارية",
  "common.bestValue": "أفضل قيمة",
  "common.billingDetailsAndroid": "لعرض الفترة التجريبية المجانية، لن يتم تحصيل رسوم منك إذا ألغيت قبل 24 ساعة من انتهاء الفترة التمهيدية المجانية. عند انتهاء الفترة التجريبية، يمكنك إلغاء اشتراك SmartMixin في أي وقت من خلال إعدادات حساب Google Play، أو سيتم تجديده تلقائياً. يجب القيام بذلك قبل 24 ساعة من نهاية فترة الاشتراك لتجنب تحصيل رسوم أخرى كما هو موضح في الزر أعلاه. سيتم تحصيل رسوم الاشتراك من حساب Google Play عند تأكيد عملية الشراء وعند بدء كل فترة تجديد.",
  "common.billingDetailsIos": "لعرض الفترة التجريبية المجانية، لن يتم تحصيل رسوم منك إذا ألغيت قبل 24 ساعة من انتهاء الفترة التمهيدية المجانية. عند انتهاء الفترة التجريبية، يمكنك إلغاء اشتراك SmartMixin في أي وقت من خلال إعدادات حساب متجر التطبيقات، أو سيتم تجديده تلقائياً. يجب القيام بذلك قبل 24 ساعة من نهاية فترة الاشتراك لتجنب تحصيل رسوم أخرى كما هو موضح في الزر أعلاه. سيتم تحصيل رسوم الاشتراك من حساب متجر التطبيقات عند تأكيد عملية الشراء وعند بدء كل فترة تجديد.",
  "common.boilerOn": "المرجل يعمل",
  "common.browseByCategory": "تصفح حسب الفئة",
  "common.calendarView": "عرض التقويم",
  "common.cancel": "إلغاء",
  "common.cannotBeEmpty": "لا يمكن أن يكون هذا الحقل فارغاً.",
  "common.cardDetails": "تفاصيل البطاقة",
  "common.categoryNotFound": "الفئة غير موجودة",
  "common.categoryNotFoundDescription": "هذه الفئة غير موجودة أو لا تحتوي على مقالات.",
  "common.charts": "الرسوم البيانية",
  "common.chartView": "عرض الرسم البياني",
  "common.clearRecentLocations": "مسح الكل",
  "common.close": "إغلاق",
  "common.comparison": "المقارنة",
  "common.contactMe": "تواصل معي",
  "common.currentDay": "اليوم الحالي",
  "common.currentLocation": "الموقع الحالي",
  "common.currentObservations": "الرصدات الحالية",
  "common.currentRainEvent": "حدث المطر الحالي",
  "common.currentRate": "المعدل الحالي",
  "common.currentWeatherConditions": "الأحوال الجوية الحالية",
  "common.customizeComparisonMetrics": "تخصيص مقاييس المقارنة",
  "common.customizeComparisonMetricsDescription": "اسحب العناصر لإعادة ترتيب مقاييس المقارنة. انقر على أيقونة العين لإظهار أو إخفاء المقاييس.",
  "common.customizeDashboard": "تخصيص",
  "common.customizeDashboardDescription": "اسحب العناصر لإعادة ترتيب لوحة المعلومات. انقر على أيقونة العين لإظهار أو إخفاء الأقسام.",
  "common.customizedStationName": "اسم المحطة المخصص",
  "common.dailyForecast": "التوقعات اليومية",
  "common.dashboard": "لوحة التحكم",
  "common.default": "افتراضي",
  "common.defaultForecastModelChip": "افتراضي · {name}",
  "common.delete": "حذف",
  "common.deleteAccount": "حذف حسابك",
  "common.deleteAccountConfirmation": "هل أنت متأكد من رغبتك في حذف حسابك؟ هذا الإجراء لا رجعة فيه.",
  "common.deleteAccountDescription": "هذا الإجراء يحذف حسابك وجميع معلوماتك. لا يوجد تراجع.",
  "common.details": "التفاصيل",
  "common.edit": "تعديل",
  "common.editor": "المحرر",
  "common.endTime": "وقت الانتهاء",
  "common.exitFullscreen": "إنهاء ملء الشاشة",
  "common.exploreWeatherMap": "استكشف خريطة الطقس",
  "common.favoriteLocations": "المفضلة",
  "common.favoriteLocationsEmpty": "يمكنك إضافة ما يصل إلى 5 مواقع مفضلة.",
  "common.favoriteStations": "المحطات المفضلة",
  "common.feedbackHelpsImprove": "تساعدنا ملاحظاتك على تحسين مقالات المساعدة.",
  "common.feedbackReasonNotAnswer": "لا يجيب على سؤالي",
  "common.feedbackReasonOutdated": "المعلومات قديمة",
  "common.feedbackReasonUnclear": "التعليمات غير واضحة",
  "common.feedbackWhatWentWrong": "ما هي المشكلة؟",
  "common.filterStationDescription": "عدم عرض المحطات ذات القياسات غير الموثوقة",
  "common.filterStations": "تصفية المحطات",
  "common.filterStationSourceDescription": "اختر مزودي المحطات الذين تريد عرضهم على الخريطة",
  "common.findStationsNearYou": "ابحث عن محطات قريبة منك",
  "common.firmwareVersion": "إصدار البرنامج الثابت",
  "common.forecast": "التوقعات",
  "common.forecastComparisonDescription": "قارن بسهولة مخرجات نماذج التوقعات من عدة مصادر",
  "common.forecastModelComparison": "مقارنة نماذج التوقعات",
  "common.forecastModelCoverage": "التغطية",
  "common.forecastModelDescription": "الوصف",
  "common.forecastModelDescription_AROME": "نموذج عالي الدقة من Météo France يسمح بحل العواصف الحمل، يغطي أوروبا الغربية بدقة 1.3 كم. الأفضل في فئته للتنبؤات قصيرة المدى في فرنسا؛ يتم تحديثه كل ثلاث ساعات.",
  "common.forecastModelDescription_ARPEGE_EU": "العش الأوروبي لنموذج ARPEGE التابع لـ Météo France بدقة 10 كم. توقعات متوسطة المدى عبر أوروبا، يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "نموذج الطقس الرقمي العالمي لـ Météo France بدقة 25 كم، يصل حتى حوالي 4 أيام. يتم تحديثه أربع مرات يوميًا.",
  "common.forecastModelDescription_EC_GDPS": "نظام التنبؤ الحتمي العالمي لبيئة كندا: نموذج عالمي متوسط ​​المدى بدقة 15 كم يصل إلى 10 أيام، يتم تحديثه مرتين يوميًا.",
  "common.forecastModelDescription_EC_RDPS": "نظام التنبؤ الحتمي الإقليمي لبيئة كندا: نموذج متوسط ​​المدى لأمريكا الشمالية بدقة 10 كم، يتم تحديثه أربع مرات يوميًا.",
  "common.forecastModelDescription_ECMWF_HRES": "النموذج عالي الدقة (IFS) للمركز الأوروبي للتنبؤات الجوية متوسطة المدى، ويُعد على نطاق واسع أفضل نظام تنبؤ عالمي في العالم. يغطي الكوكب بأكمله بدقة 25 كم حتى 15 يومًا، ويُحدَّث أربع مرات يوميًا. يحتوي على بيانات ECMWF المفتوحة المعدلة (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "النموذج العالمي الرئيسي متوسط ​​المدى من NOAA. يغطي الكوكب بأكمله بدقة 25 كم وحتى 16 يومًا، يتم تحديثه أربع مرات يوميًا.",
  "common.forecastModelDescription_HRRR_CONUS": "نموذج التحديث السريع عالي الدقة من NOAA: نموذج يسمح بحل العواصف الحمل عبر الولايات المتحدة القارية بدقة 3 كم، يتم تحديثه كل ساعة. الأنسب للتنبؤات قصيرة المدى للعواصف الرعدية والطقس الشديد.",
  "common.forecastModelDescription_ICON_DE": "نموذج DWD عالي الدقة يسمح بحل العواصف الحمل عبر ألمانيا والدول المجاورة بدقة 2.2 كم. توقعات قصيرة المدى يتم تحديثها مرتين يوميًا.",
  "common.forecastModelDescription_ICON_EU": "العش الأوروبي لنموذج ICON التابع لـ DWD بدقة 7 كم يغطي أوروبا وشمال المحيط الأطلسي. توقعات متوسطة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_MET_NORWAY": "خدمة التنبؤ بالطقس المفتوحة لمعهد الأرصاد الجوية النرويجي، تجمع بين النماذج الشمالية عالية الدقة وبيانات ECMWF لتقديم توقعات عالمية تصل إلى 10 أيام.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "عش AROME فوق جزر الأنتيل الفرنسية (غوادلوب، مارتينيك) بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "عش AROME فوق غويانا الفرنسية بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "عش AROME فوق كاليدونيا الجديدة بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "عش AROME فوق بولينيزيا الفرنسية بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "عش AROME فوق ريونيون ومايوت بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_NAM_CONUS": "عش نموذج NAM التابع لـ NOAA على نطاق متوسط ​​فوق الولايات المتحدة القارية بدقة 5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "نموذج NAM التابع لـ NOAA على نطاق متوسط ​​يغطي كامل أمريكا الشمالية بدقة 32 كم. يتم تحديثه أربع مرات يوميًا.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "توقعات SmartMixin الرائدة. لكل ساعة في موقعك، نختار أفضل نموذج متاح — عادةً ما يكون نموذجًا إقليميًا عالي الدقة حيثما وجد (AROME في فرنسا، ICON-D2 في ألمانيا، HRRR في الولايات المتحدة، ARPEGE Europe عبر القارة…) ونعود إلى نموذج عالمي في أماكن أخرى — ثم نملأ أي فجوات من المصادر المجاورة. النتيجة هي توقعات واحدة سلسة تغطي أي مكان في العالم حتى 14 يومًا، يتم تحديثها تلقائيًا كلما تم تحديث أي من النماذج الأساسية.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "التوقعات العالمية المملوكة لـ Weatherflow التي تمزج نماذج عددية متعددة للطقس مع ملاحظات من شبكتها لمحطات الطقس Tempest. أفق عالمي مدته 10 أيام.",
  "common.forecastModelDetailTitle": "نموذج التوقعات",
  "common.forecastModelScopeGlobal": "عالمي",
  "common.forecastModelScopeGlobalDescription": "يغطي هذا النموذج الكوكب بأكمله.",
  "common.forecastModelScopeRegional": "إقليمي",
  "common.forecastModelScopeRegionalDescription": "يغطي هذا النموذج منطقة محددة فقط.",
  "common.forecastModelSpecifications": "المواصفات",
  "common.forecastSources": "مصادر التوقعات",
  "common.freeAccount": "حساب مجاني",
  "common.freeSubscription": "اشتراك مميز مجاني",
  "common.freeTrialForPeriod": "فترة تجريبية مجانية لمدة {period} يوماً",
  "common.frequency": "التردد",
  "common.full": "كامل",
  "common.fullscreen": "ملء الشاشة",
  "common.getStartedFree": "ابدأ مجاناً",
  "common.getUnlimitedAccess": "وصول غير محدود إلى:",
  "common.good": "جيد",
  "common.hail": "بَرَد",
  "common.help": "مساعدة",
  "common.helpCategoryAccount": "الحساب",
  "common.helpCategoryBilling": "الفواتير",
  "common.helpCategoryGettingStarted": "البدء",
  "common.helpCategoryProviders": "مزودو الخدمة",
  "common.helpCategoryStations": "المحطات",
  "common.helpCategoryTroubleshooting": "استكشاف الأخطاء وإصلاحها",
  "common.helpCenter": "مركز المساعدة",
  "common.helpCenterDescription": "ابحث عن إجابات للأسئلة الشائعة وتعلم كيفية الاستفادة القصوى من SmartMixin.",
  "common.hg": "الحماية من الصقيع",
  "common.hidden": "مخفي",
  "common.hiddenSensors": "أجهزة استشعار مخفية",
  "common.hiddenStations": "المحطات المخفية",
  "common.hiddenStationsDescription": "يمكنك إظهار المحطة بالنقر على أيقونة العين بجانبها.",
  "common.high": "مرتفع",
  "common.home": "الرئيسية",
  "common.homeConnectService": "هل تملك محطة أرصاد جوية؟ قم بربط خدمتك",
  "common.homeInformation": "معلومات المنزل",
  "common.homeIntroduction": "ابدأ بربط حساباتك الخارجية للاستمتاع بميزات SmartMixin.",
  "common.homeName": "اسم المنزل",
  "common.homeSubtitle": "طقسك، كل شيء في مكان واحد",
  "common.horizon": "الأفق",
  "common.horizonValue": "حتى {value} ساعات",
  "common.iDontKnowYet": "لا أعرف بعد",
  "common.indoor": "داخلي",
  "common.lastRainEvent": "آخر حدث مطري",
  "common.lastUpdate": "آخر تحديث",
  "common.legendHeavy": "غزير",
  "common.legendLight": "خفيف",
  "common.legendLightningHelp": "يوضح اللون عمر كل صاعقة خلال آخر {minutes} دقيقة — الأحدث باللون الأبيض والأقدم باللون الأحمر الداكن.",
  "common.legendNewest": "الأحدث",
  "common.legendOldest": "الأقدم",
  "common.legendStationsHelp": "يعكس لون العلامة قيمة المقياس المحدد.",
  "common.lightningDataAttribution": "بيانات البرق: Blitzortung.org",
  "common.lightningStrikes": "ضربات البرق",
  "common.lightningStrikesDescription": "عرض ضربات البرق في الوقت الفعلي على الخريطة",
  "common.linkToSection": "رابط إلى هذا القسم",
  "common.loading": "جاري التحميل",
  "common.location": "الموقع",
  "common.locationAddedToFavorites": "تمت إضافة الموقع إلى المفضلة",
  "common.locationNotGranted": "لم يتم منح إذن الموقع. يرجى السماح بالوصول إلى موقعك في إعدادات الجهاز.",
  "common.locationRemovedFromFavorites": "تمت إزالة الموقع من المفضلة",
  "common.locations": "المواقع",
  "common.low": "منخفض",
  "common.manage": "إدارة",
  "common.manageAccount": "إدارة الحساب",
  "common.manageMySubscription": "إدارة اشتراكي",
  "common.manageSensors": "إدارة أجهزة الاستشعار",
  "common.manageSensorsDescription": "اسحب العناصر لإعادة ترتيب أجهزة الاستشعار. انقر على أيقونة العين لإظهار أو إخفاء أجهزة الاستشعار. انقر على الاسم لإعادة تسميته.",
  "common.manualBoost": "تعزيز يدوي",
  "common.manualSetpointUntil": "نقطة الضبط اليدوية حتى",
  "common.mapLayers": "طبقات الخريطة",
  "common.mapLegend": "مفتاح الخريطة",
  "common.maxFavoriteLocationsReached": "يمكنك الاحتفاظ بـ 5 مواقع مفضلة فقط. احذف واحداً لإضافة آخر.",
  "common.maximum": "الحد الأقصى",
  "common.measureToDisplay": "القياس المراد عرضه",
  "common.medium": "متوسط",
  "common.meshSize": "حجم الشبكة",
  "common.minimum": "الحد الأدنى",
  "common.minRead": "{minutes} دقيقة قراءة",
  "common.modifyFavoriteStations": "تعديل المحطات المفضلة",
  "common.modifyFavoriteStationsDescription": "يمكنك إعادة ترتيب محطاتك المفضلة بسحبها. يمكنك أيضاً إزالتها من القائمة.",
  "common.moduleType": "نوع الوحدة",
  "common.monthTotal": "إجمالي الشهر",
  "common.more": "المزيد",
  "common.moreInformation": "مزيد من المعلومات",
  "common.myLocation": "موقعي",
  "common.nearbyWeatherStations": "محطات الطقس القريبة",
  "common.next": "التالي",
  "common.nextHours": "الساعات القادمة",
  "common.no": "لا",
  "common.noAccountNeeded": "لا حاجة لحساب",
  "common.noDataForThisPeriod": "لا توجد بيانات لهذه الفترة",
  "common.noLocationsFound": "لم يتم العثور على مواقع",
  "common.noNetatmoWeatherStationYet": "ليس لديك محطة Netatmo للطقس بعد.",
  "common.noOutdoorModule": "لا توجد وحدة خارجية تعمل لهذه المحطة.",
  "common.noSearchResults": "لا توجد مقالات مطابقة لبحثك",
  "common.noStationsFound": "لم يتم العثور على محطات",
  "common.noThermostatYet": "ليس لديك منظم حرارة بعد.",
  "common.notNow": "ليس الآن",
  "common.notPurchasedYet": "يبدو أن هذا لم يتم شراؤه بعد.",
  "common.noWeatherStation": "لا توجد محطة طقس",
  "common.noWeatherStationYet": "ليس لديك محطة طقس بعد.",
  "common.numberOfActiveWarnings": "{warning_count} تحذيرات جوية نشطة",
  "common.onThisPage": "في هذه الصفحة",
  "common.openSettings": "فتح الإعدادات",
  "common.orChooseMonthly": "أو اختر الشهري:",
  "common.outdatedModule": "بيانات هذه الوحدة قديمة.",
  "common.outdoor": "خارجي",
  "common.outdoorTemperature": "درجة الحرارة الخارجية",
  "common.pageNotFound": "الصفحة غير موجودة",
  "common.pageNotFoundDescription": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  "common.passwordUpdated": "تم تحديث كلمة المرور بنجاح.",
  "common.personalWeatherIntelligence": "ذكاء الطقس الشخصي الخاص بك",
  "common.platformMobileApp": "تطبيق الجوال",
  "common.platformMobileOnly": "تطبيق الجوال فقط",
  "common.platformWebApp": "تطبيق الويب",
  "common.platformWebOnly": "تطبيق الويب فقط",
  "common.popularArticles": "المقالات الشائعة",
  "common.premiumAccount": "حساب مميز",
  "common.premiumDescription": "يفتح الاشتراك المميز العديد من الميزات الإضافية مثل تحليل الطقس المتقدم ومقارنات الرسوم البيانية ونماذج التوقعات الإقليمية والمزيد.",
  "common.premiumFeatureAlerts": "تنبيهات الطقس",
  "common.premiumFeatureAnalysis": "تحليل الطقس المتقدم",
  "common.premiumFeatureCharts": "مقارنات الرسوم البيانية",
  "common.premiumFeatureExport": "تصدير البيانات",
  "common.premiumFeatureForecast": "نماذج التوقعات الإقليمية",
  "common.premiumFeatureNotification": "أداة شريط الحالة",
  "common.premiumFeatureTitle": "ميزة مميزة",
  "common.premiumFeatureWidgets": "أدوات الشاشة الرئيسية",
  "common.pressureSummary": "ملخص الضغط الجوي",
  "common.previous": "السابق",
  "common.previousHours": "الساعات السابقة",
  "common.profileUpdated": "تم تحديث الملف الشخصي بنجاح.",
  "common.purchasedNetatmoPro": "لقد اشتريت سابقاً Netatmo Pro ({date}). يمنحك هذا الوصول إلى مجموعة فرعية من الميزات المميزة. اشترك في أحد العروض التالية إذا كنت تريد الوصول إلى جميع الميزات المميزة.",
  "common.radarDataAttribution": "بيانات الرادار: RainViewer.com",
  "common.rain": "المطر",
  "common.rainEvents": "أحداث الأمطار",
  "common.rainfallMeasurement": "قياس هطول الأمطار",
  "common.rainRadar": "رادار المطر",
  "common.rainRadarDescription": "عرض طبقة رادار المطر على الخريطة",
  "common.rainSummary": "ملخص الأمطار",
  "common.range": "النطاق",
  "common.recentLocations": "الأخيرة",
  "common.recentLocationsEmpty": "سجل المواقع الأخيرة فارغ.",
  "common.recentStations": "المحطات الأخيرة",
  "common.relatedArticles": "مقالات ذات صلة",
  "common.relay": "المرحل",
  "common.removeFromFavorites": "إزالة من المفضلة",
  "common.renameSensors": "إعادة تسمية أجهزة الاستشعار",
  "common.resetZoom": "إعادة تعيين التكبير",
  "common.restorePurchase": "استعادة الشراء",
  "common.room": "الغرفة",
  "common.rooms": "الغرف",
  "common.savingsPercent": "وفر {percent}%",
  "common.searchArticles": "البحث في المقالات...",
  "common.searchForALocation": "ابحث عن موقع...",
  "common.searchForLocation": "البحث عن موقع",
  "common.searchForWeatherStation": "البحث عن محطة طقس",
  "common.searchResults": "نتائج البحث",
  "common.searchResultsEmpty": "لم يتم العثور على نتائج.",
  "common.searchResultsFound": "{count, plural, zero {لم يتم العثور على نتائج} one {تم العثور على نتيجة واحدة} two {تم العثور على نتيجتين} few {تم العثور على # نتائج} many {تم العثور على # نتيجة} other {تم العثور على # نتيجة}}",
  "common.searchStationsDescription": "أدخل مدينة أو عنوان أو اسم مكان للعثور على محطات الطقس القريبة.",
  "common.searchStationsHint": "استخدم شريط البحث أعلاه لاكتشاف محطات الطقس في أي مكان في العالم.",
  "common.selectStationForComparison": "اختر محطة للمقارنة",
  "common.selectWeatherForecastProvider": "يرجى اختيار مزود توقعات الطقس",
  "common.serialNumber": "الرقم التسلسلي",
  "common.share": "مشاركة",
  "common.shareOutdoorMeasures": "شارك قياساتك الخارجية",
  "common.shareOutdoorMeasuresDescription": "شارك في مجتمع SmartMixin بجعل قياساتك الخارجية مرئية للآخرين. لن تتم مشاركة القياسات الداخلية أبداً.",
  "common.shareYourWeather": "شارك طقسك",
  "common.signalStrength": "قوة الإشارة",
  "common.skip": "تخطي",
  "common.smartThermostat": "منظم حرارة ذكي",
  "common.smartValve": "صمام ذكي",
  "common.snow": "ثلج",
  "common.start": "البداية",
  "common.startFreeTrial": "ابدأ التجربة المجانية",
  "common.startTime": "وقت البدء",
  "common.station": "محطة",
  "common.stationAddedToFavorites": "تمت إضافة المحطة إلى المفضلة",
  "common.stationComparison": "مقارنة المحطات",
  "common.stationComparisonDescription": "قارن بيانات الطقس التاريخية مع محطة أخرى",
  "common.stationInformation": "معلومات المحطة",
  "common.stationName": "اسم المحطة",
  "common.stationObservationsDescription": "عرض أحدث الرصدات من محطات الطقس",
  "common.stationRemovedFromFavorites": "تمت إزالة المحطة من المفضلة",
  "common.stations": "محطات",
  "common.stationsNear": "محطات قريبة من",
  "common.stationType": "نوع المحطة",
  "common.statusOffline": "غير متصل",
  "common.statusOnline": "متصل",
  "common.statusStale": "قديم",
  "common.statusSyncing": "مزامنة",
  "common.stillNeedHelp": "هل ما زلت بحاجة إلى مساعدة؟",
  "common.stillNeedHelpDescription": "إذا لم يجب هذا المقال على سؤالك، يسعدني مساعدتك مباشرة.",
  "common.subscribeNow": "اشترك الآن - بدون فترة تجريبية",
  "common.sumOverThePeriod": "المجموع التراكمي خلال الفترة",
  "common.switchToPremium": "التبديل إلى SmartMixin Premium",
  "common.temperatureShort": "حرارة",
  "common.temperatureSummary": "ملخص درجة الحرارة",
  "common.thankYouForFeedback": "شكراً لملاحظاتك!",
  "common.thenPrice": "ثم {price}",
  "common.timeSelection": "اختيار الوقت",
  "common.timezone": "المنطقة الزمنية",
  "common.totalDuration": "المدة الإجمالية",
  "common.tryAnotherLocation": "لم نتمكن من العثور على محطات طقس قريبة من هذا الموقع. جرب البحث في منطقة مختلفة.",
  "common.unknown": "غير معروف",
  "common.untilChanged": "حتى التغيير",
  "common.untilTime": "حتى {time}",
  "common.updateAvailable": "يتوفر تحديث",
  "common.updateAvailableOpenAppStore": "انقر لفتح App Store",
  "common.updateAvailableOpenGooglePlay": "انقر لفتح Google Play",
  "common.updateAvailableVersion": "يتوفر تحديث: v{version}",
  "common.upgrade": "ترقية",
  "common.upgradeRequiredAndroid": "يلزم ترقية تطبيقك. قم بزيارة Google Play للترقية.",
  "common.upgradeRequiredIos": "يلزم ترقية تطبيقك. قم بزيارة متجر التطبيقات للترقية.",
  "common.validate": "تأكيد",
  "common.validEmail": "مطلوب عنوان بريد إلكتروني صالح.",
  "common.very_low": "منخفض جداً",
  "common.visitNetatmoWebsite": "زيارة موقع Netatmo",
  "common.wasArticleHelpful": "هل كانت هذه المقالة مفيدة؟",
  "common.weatherCondition": "حالة الطقس",
  "common.weatherflowNCRain": "NC Rain (مطر Nearcast)",
  "common.weatherflowNCRainDescription": "NC Rain هو مصدر بيانات إضافي يتم توفيره عبر نظام Tempest للطقس، مدعوم بتقنية Nearcast. بيانات NC Rain هي تقدير لمتوسط تراكم هطول الأمطار حول جهاز Tempest الخاص بك على مستوى الحي",
  "common.weatherForecastModels": "نماذج التوقعات الجوية",
  "common.weatherIntelligencePlatform": "منصة ذكاء الطقس",
  "common.weatherMap": "خريطة الطقس",
  "common.weatherMapMetaDescription": "SmartMixin يوفر خرائط تفاعلية للطقس والرادار لظروف الطقس في جميع أنحاء العالم.",
  "common.weatherObservations": "رصدات الطقس",
  "common.weatherStation": "محطة الطقس",
  "common.weatherStations": "محطات الطقس",
  "common.welcome": "مرحباً بك في SmartMixin!",
  "common.whenBackHome": "متى ستعود إلى المنزل؟",
  "common.wifiStrength": "قوة الواي فاي",
  "common.wind": "الرياح",
  "common.windMeasurement": "قياس الرياح",
  "common.windSpeed": "سرعة الرياح",
  "common.windSummary": "ملخص الرياح",
  "common.yearToDate": "منذ بداية السنة",
  "common.yes": "نعم",
  "common.zoomImage": "تكبير الصورة",
  "forecastMaps.addColor": "إضافة لون",
  "forecastMaps.addLayer": "إضافة طبقة",
  "forecastMaps.autoPreview": "تلقائي",
  "forecastMaps.backToMaps": "العودة إلى الخرائط",
  "forecastMaps.browseMaps": "تصفح الخرائط",
  "forecastMaps.build": "إنشاء",
  "forecastMaps.buildCompleted": "اكتمل الإنشاء",
  "forecastMaps.builderMetaDescription": "أنشئ خرائط توقعات مخصصة من طبقات نماذج الطقس.",
  "forecastMaps.builderTitle": "منشئ الخرائط",
  "forecastMaps.buildFailed": "فشل الإنشاء. يرجى المحاولة مرة أخرى.",
  "forecastMaps.buildNotPossible": "لا يمكن إنشاء هذه الخريطة بعد — لا توجد بيانات توقعات متاحة.",
  "forecastMaps.buildProgress": "جارٍ الرسم… {completed}/{total} خطوة",
  "forecastMaps.buildStarting": "جارٍ بدء الإنشاء…",
  "forecastMaps.byModel": "حسب النموذج",
  "forecastMaps.byZone": "حسب المنطقة",
  "forecastMaps.colormap": "تدرج الألوان",
  "forecastMaps.colormapCustom": "ألوان مخصصة",
  "forecastMaps.colormapGroupDomain": "إعدادات الطقس المسبقة",
  "forecastMaps.colormapGroupMatplotlib": "إعدادات علمية مسبقة",
  "forecastMaps.colorScale": "مقياس الألوان",
  "forecastMaps.comingSoon": "هذا العرض قادم قريبًا.",
  "forecastMaps.contourLevels": "مستويات الكنتور",
  "forecastMaps.countryCanada": "كندا",
  "forecastMaps.countryFrance": "فرنسا",
  "forecastMaps.countryGermany": "ألمانيا",
  "forecastMaps.countryItaly": "إيطاليا",
  "forecastMaps.countryScandinavia": "إسكندنافيا",
  "forecastMaps.countrySpain": "إسبانيا",
  "forecastMaps.countrySwitzerland": "سويسرا",
  "forecastMaps.countryUnitedStates": "الولايات المتحدة",
  "forecastMaps.customColormapMinColors": "يتطلب تدرج الألوان المخصص لونين على الأقل",
  "forecastMaps.customExtent": "نطاق مخصص",
  "forecastMaps.deleteMap": "حذف الخريطة",
  "forecastMaps.deleteMapBody": "سيتم حذف \"{name}\" وعمليات الرسم الخاصة بها نهائيًا.",
  "forecastMaps.deleteMapTitle": "هل تريد حذف هذه الخريطة؟",
  "forecastMaps.displayName": "الاسم المعروض",
  "forecastMaps.downloadMp4": "تنزيل MP4",
  "forecastMaps.downscaling": "معامل تخفيف أسهم الرياح",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "رسم المنطقة",
  "forecastMaps.east": "شرق",
  "forecastMaps.editMap": "تعديل الخريطة",
  "forecastMaps.exportBuilding": "جارٍ تجهيز الفيديو…",
  "forecastMaps.exportError": "فشل تصدير الفيديو. يرجى المحاولة مرة أخرى.",
  "forecastMaps.exportMp4": "تصدير MP4",
  "forecastMaps.exportNotReady": "الفيديو غير جاهز بعد. يرجى المحاولة لاحقًا.",
  "forecastMaps.extentDrawHint": "اسحب على الخريطة لرسم المنطقة",
  "forecastMaps.extentInvalid": "يجب أن يكون الغرب أصغر من الشرق والجنوب أصغر من الشمال",
  "forecastMaps.extentPanZoomHint": "حرّك الخريطة وكبّرها حتى تملأ المنطقة الإطار",
  "forecastMaps.flipbookView": "رسم متحرك",
  "forecastMaps.forecastModel": "نموذج التوقعات",
  "forecastMaps.forkAndEdit": "نسخ وتعديل",
  "forecastMaps.height": "الارتفاع (بوصة)",
  "forecastMaps.hourOffset": "+{hour} س",
  "forecastMaps.invalidHexColor": "لون غير صالح — استخدم ‎#RRGGBB",
  "forecastMaps.layers": "الطبقات",
  "forecastMaps.layerTypeBarbs": "أسهم الرياح",
  "forecastMaps.layerTypeContour": "خطوط الكنتور",
  "forecastMaps.layerTypeFilledContour": "كنتور معبأ",
  "forecastMaps.layerTypeMagnitude": "المقدار",
  "forecastMaps.layerTypeRaster": "نقطي",
  "forecastMaps.layerTypeVectorField": "حقل متجهات",
  "forecastMaps.leave": "مغادرة",
  "forecastMaps.levelsCount": "العدد",
  "forecastMaps.levelsInvalid": "مستويات كنتور غير صالحة",
  "forecastMaps.levelsModeArange": "خطوة ثابتة",
  "forecastMaps.levelsModeExplicit": "قيم صريحة",
  "forecastMaps.levelsModeLinspace": "متباعدة بانتظام (العدد)",
  "forecastMaps.levelsStep": "الخطوة",
  "forecastMaps.levelsValues": "القيم",
  "forecastMaps.levelsValuesHint": "مفصولة بفواصل، تصاعديًا",
  "forecastMaps.localTimeHint": "يظهر بتوقيتك المحلي",
  "forecastMaps.map": "خريطة",
  "forecastMaps.mapDescription": "الوصف",
  "forecastMaps.mapName": "اسم الخريطة",
  "forecastMaps.mapNameRequired": "أدخل اسمًا",
  "forecastMaps.mapSettings": "إعدادات الخريطة",
  "forecastMaps.mapView": "خريطة تفاعلية",
  "forecastMaps.maxLayersReached": "وصلت هذه الخريطة إلى الحد الأقصى وهو {max} طبقات.",
  "forecastMaps.maxValue": "القيمة القصوى",
  "forecastMaps.memoryBudgetExceeded": "تتجاوز الدقة ميزانية الرسم — قلّل DPI أو الارتفاع",
  "forecastMaps.memoryBudgetUsage": "ميزانية الرسم: {percent}%",
  "forecastMaps.metaDescription": "خرائط توقعات متحركة مُنشأة من حسابات نماذج الطقس.",
  "forecastMaps.metric": "القياس",
  "forecastMaps.metricRequired": "اختر قياسًا",
  "forecastMaps.metricUnavailable": "غير متاح لهذا النموذج",
  "forecastMaps.minBelowMax": "يجب أن يكون الحد الأدنى أصغر من الحد الأقصى",
  "forecastMaps.minMaxRequired": "القيمتان الدنيا والقصوى مطلوبتان لهذا النوع من الطبقات",
  "forecastMaps.minValue": "القيمة الدنيا",
  "forecastMaps.modelNoRun": "لا يوجد تشغيل مكتمل بعد",
  "forecastMaps.moveLayerDown": "نقل لأسفل",
  "forecastMaps.moveLayerUp": "نقل لأعلى",
  "forecastMaps.myMaps": "خرائطي",
  "forecastMaps.nanClipToMin": "تقييد إلى الحد الأدنى",
  "forecastMaps.nanMask": "إخفاء",
  "forecastMaps.nanPolicy": "بيانات مفقودة",
  "forecastMaps.nanSkip": "تخطي",
  "forecastMaps.newMap": "خريطة جديدة",
  "forecastMaps.noCompletedRun": "لم يتم إنشاء هذه الخريطة بعد. يرجى التحقق مرة أخرى قريبًا.",
  "forecastMaps.noLayers": "لا توجد طبقات بعد. أضف طبقة للبدء.",
  "forecastMaps.noMapsAvailable": "لا توجد خرائط توقعات متاحة بعد.",
  "forecastMaps.north": "شمال",
  "forecastMaps.opacity": "العتامة",
  "forecastMaps.overlayLegend": "مفتاح الخريطة",
  "forecastMaps.pause": "إيقاف مؤقت",
  "forecastMaps.play": "تشغيل",
  "forecastMaps.pointValueError": "تعذر تحميل التوقعات لهذه النقطة.",
  "forecastMaps.pointValueLoading": "جارٍ تحميل التوقعات…",
  "forecastMaps.pointValueUnavailable": "لا توجد بيانات لهذا الوقت.",
  "forecastMaps.presets": "إعدادات مسبقة",
  "forecastMaps.preview": "معاينة",
  "forecastMaps.previewEmptyHint": "قم بإعداد طبقة صالحة واحدة على الأقل لرسم معاينة.",
  "forecastMaps.previewFailed": "فشلت المعاينة",
  "forecastMaps.previewHour": "ساعة التوقع",
  "forecastMaps.previewRendering": "جارٍ رسم المعاينة…",
  "forecastMaps.projection": "الإسقاط",
  "forecastMaps.projectionLambertConformal": "لامبرت المطابق",
  "forecastMaps.projectionMercator": "ميركاتور",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "مجسّم",
  "forecastMaps.regionEurope": "أوروبا",
  "forecastMaps.regionNorthAmerica": "أمريكا الشمالية",
  "forecastMaps.removeColor": "إزالة اللون",
  "forecastMaps.removeLayer": "إزالة الطبقة",
  "forecastMaps.retry": "إعادة المحاولة",
  "forecastMaps.run": "التشغيل: {run}",
  "forecastMaps.save": "حفظ",
  "forecastMaps.selectExtentOnMap": "تحديد المنطقة على الخريطة",
  "forecastMaps.south": "جنوب",
  "forecastMaps.title": "خرائط التوقعات",
  "forecastMaps.uMetric": "المركّبة U",
  "forecastMaps.unitConversion": "تحويل الوحدات",
  "forecastMaps.unitNone": "بدون",
  "forecastMaps.unsavedChangesBody": "لديك تغييرات غير محفوظة. هل تريد المغادرة وتجاهلها؟",
  "forecastMaps.unsavedChangesTitle": "تغييرات غير محفوظة",
  "forecastMaps.useCurrentView": "استخدام العرض الحالي",
  "forecastMaps.useModelDomain": "متوقف: يُستخدم نطاق النموذج بالكامل",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "يجب أن يختلف قياسا U وV",
  "forecastMaps.validTime": "وقت الصلاحية: {time}",
  "forecastMaps.valueBetween": "يجب أن تكون بين {min} و{max}",
  "forecastMaps.variable": "المتغير",
  "forecastMaps.viewMap": "عرض الخريطة",
  "forecastMaps.vMetric": "المركّبة V",
  "forecastMaps.west": "غرب",
  "forecastMaps.windAnimation": "تحريك الرياح",
  "intro.locationDescription": "فعّل الوصول إلى الموقع للحصول على توقعات دقيقة مخصصة لمنطقتك بالضبط — لا مزيد من التوقعات العامة.",
  "intro.locationTitle": "توقعات مصممة لك",
  "intro.notificationDescription": "فعّل الإشعارات للحصول على تنبيهات في الوقت المناسب حول تغيرات الطقس التي تهمك — المطر أو الثلج أو الظروف الشديدة، في الوقت الذي تحتاج فيه إلى المعرفة.",
  "intro.notificationsTitle": "لا تفوّت أي تغير في الطقس",
  "intro.readyDescription": "استمتع بتوقعات دقيقة ورؤى الطقس في الوقت الفعلي وبيانات المحطات من جميع أنحاء العالم — كل ذلك في تطبيق واحد قوي.",
  "intro.readyTitle": "أنت جاهز!",
  "intro.welcomeDescription": "احصل على توقعات محلية فائقة الدقة مدعومة من أفضل الوكالات الجوية — بالإضافة إلى الوصول إلى أكثر من 40,000 محطة طقس في جميع أنحاء العالم لرؤية الأحوال الفعلية، الماضية والحاضرة.",
  "intro.welcomeTitle": "طقسك، بصورة جديدة",
  "landing.alerts": "التنبيهات",
  "landing.alertsDescription": "أنشئ تنبيهاتك الخاصة واحصل على إشعار فور تفعيلها.",
  "landing.featureAlertsDescription": "عيّن حدودًا مخصصة لأي مقياس. احصل على إشعار عند انخفاض الحرارة أو بدء المطر أو اشتداد الرياح.",
  "landing.featureAlertsTitle": "تنبيهات ذكية",
  "landing.featureAnalyticsDescription": "رسوم بيانية تفاعلية وتحليل الاتجاهات وإحصائيات مفصلة. تعمق في بيانات الحرارة والرطوبة والضغط والأمطار والرياح.",
  "landing.featureAnalyticsTitle": "تحليلات متقدمة",
  "landing.featureExportDescription": "قم بتنزيل بيانات الطقس كملفات CSV لمزيد من التحليل في Excel أو Google Sheets أو أدواتك المفضلة.",
  "landing.featureExportTitle": "تصدير بياناتك",
  "landing.featureForecastDescription": "الوصول إلى أكثر من 10 نماذج توقعات احترافية بما في ذلك ECMWF وGFS والنماذج الإقليمية. قارنها جنبًا إلى جنب.",
  "landing.featureForecastTitle": "مقارنة نماذج التوقعات",
  "landing.featureHistoryDescription": "الوصول إلى البيانات التاريخية بمقاييس ساعية ويومية وشهرية. التصدير إلى CSV للبحث أو الأرشيفات الشخصية.",
  "landing.featureHistoryTitle": "سجل غني",
  "landing.featureMultiBrandDescription": "اربط Netatmo وDavis وTempest وEcowitt وAmbient Weather والمزيد. لا مزيد من التبديل بين التطبيقات.",
  "landing.featureMultiBrandTitle": "جميع العلامات التجارية، تطبيق واحد",
  "landing.featuresSubtitle": "SmartMixin يمنحك الأدوات لتحليل ومقارنة وفهم بيانات الطقس باحتراف.",
  "landing.featuresTitle": "مصمم لعشاق البيانات",
  "landing.finalCtaButton": "إنشاء حساب مجاني",
  "landing.finalCtaSubtitle": "انضم إلى آلاف المتحمسين للطقس الذين يثقون بـ SmartMixin.",
  "landing.finalCtaTitle": "هل أنت مستعد للتعمق أكثر في بيانات الطقس؟",
  "landing.forecastDescription": "الوصول إلى بعض أفضل نماذج التوقعات الجوية ومقارنتها للحصول على فكرتك الخاصة عن الطقس.",
  "landing.forecasts": "التوقعات",
  "landing.heroCta": "ابدأ مجانًا",
  "landing.heroDescription": "تحليلات عميقة ورسوم بيانية جميلة وتوقعات احترافية — جميع محطاتك الجوية موحدة في تطبيق واحد قوي.",
  "landing.heroSecondaryCta": "استكشف الخريطة",
  "landing.heroTagline": "لعشاق الطقس",
  "landing.heroTitle": "شاهد طقسك كما لم تره من قبل",
  "landing.pricingFeatureAdvancedMetrics": "مقاييس متقدمة",
  "landing.pricingFeatureAlerts": "تنبيهات مخصصة",
  "landing.pricingFeatureExport": "تصدير البيانات (CSV)",
  "landing.pricingFeatureForecastComparison": "مقارنة التوقعات",
  "landing.pricingFeatureForecasts": "نماذج التوقعات",
  "landing.pricingFeatureForecastsFreeTier": "نموذج واحد",
  "landing.pricingFeatureForecastsPremiumTier": "أكثر من 10 نماذج",
  "landing.pricingFeatureReports": "التحليلات والتقارير",
  "landing.pricingFeatureStationComparison": "مقارنة المحطات",
  "landing.pricingFeatureWidgets": "أدوات الشاشة الرئيسية",
  "landing.pricingFeatureYearOverYear": "تحليل سنة بسنة",
  "landing.pricingFree": "مجاني",
  "landing.pricingFreeCta": "ابدأ الآن",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "الأكثر شعبية",
  "landing.pricingPremium": "مميز",
  "landing.pricingPremiumCta": "ابدأ الآن",
  "landing.pricingPremiumDescription": "من 1.99 €/شهر — اشترك على الويب أو App Store أو Google Play",
  "landing.pricingSubtitle": "ابدأ مجانًا، وقم بالترقية عندما تحتاج المزيد.",
  "landing.pricingTitle": "أسعار بسيطة وشفافة",
  "landing.smartMixinDescription": "SmartMixin هو تطبيق يوفر الوصول إلى محطة الطقس الخاصة بك وأكثر من 40 ألف محطة أخرى حول العالم. يساعدك على رؤية وفهم بيانات الطقس.",
  "landing.statBrands": "علامات تجارية مدعومة",
  "landing.statForecasts": "نماذج التوقعات",
  "landing.statStations": "محطات الطقس",
  "landing.supportedDevices": "الأجهزة المدعومة",
  "landing.supportedDevicesDescription": "بالإضافة إلى محطات المنظمة العالمية للأرصاد الجوية، يدعم SmartMixin عدداً متزايداً من العلامات التجارية لمحطات الطقس.",
  "landing.supportedDevicesNote": "بالإضافة إلى أكثر من 40,000 محطة عامة من المنظمة العالمية للأرصاد الجوية",
  "landing.supportedDevicesSubtitle": "اربط محطة الطقس الموجودة لديك في دقائق. ندعم 8 علامات تجارية رئيسية والعدد في ازدياد.",
  "landing.supportedDevicesTitle": "يعمل مع محطتك",
  "landing.thermostatDescription": "اربط منظم الحرارة Netatmo لربط أنماط التدفئة بالظروف الخارجية.",
  "landing.thermostatManufacturers": "يتم دعم مصنعي منظمات الحرارة أيضاً لربط التدفئة بالظروف الخارجية.",
  "landing.thermostatTitle": "تكامل المنزل الذكي",
  "landing.weatherAnalysis": "تحليل الطقس",
  "landing.weatherAnalysisDescription": "يأتي SmartMixin مع الكثير من تصورات البيانات التي تتيح لك تحليل بيانات الطقس.",
  "landing.weatherAssistant": "مساعدك الجوي",
  "landing.weatherAssistantDescription": "سواء كنت مهتماً بأحوال الطقس الحالية أو التاريخية أو المتوقعة، يوفر لك SmartMixin رؤى عديدة متى احتجت إليها.",
  "landing.weatherForecastModels": "نماذج التوقعات الجوية",
  "landing.weatherForecastModelsDescription": "يوفر SmartMixin الوصول إلى أدق نماذج التوقعات الجوية. يمكنك بسهولة مقارنة توقعاتها وتكوين فكرتك الخاصة.",
  "landing.weatherMap": "خريطة الطقس",
  "landing.weatherMapDescription": "تصفح الخريطة وتصور حالة الطقس في أي مكان حول العالم.",
  "network.cancelError": "تم إلغاء الطلب",
  "network.connectionError": "الخادم غير متاح",
  "network.networkError": "الشبكة غير متاحة",
  "network.serverError": "حدث خطأ ما...",
  "network.timeoutError": "انتهت مهلة الاتصال",
  "network.unknownError": "خطأ غير معروف",
  "providerHints.ambientWeatherApiKey": "تم إنشاؤه في إعدادات حسابك على ambientweather.net.",
  "providerHints.davisApiSecret": "يظهر مرة واحدة فقط عند إنشاء مفتاح V2 API — احتفظ به بأمان.",
  "providerHints.davisV2ApiKey": "من صفحة مفاتيح V2 API على weatherlink.com.",
  "providerHints.ecowittApi": "من صفحة API لحساب Ecowitt الخاص بك.",
  "providerHints.ecowittApp": "مفتاح التطبيق، أيضًا من حساب Ecowitt الخاص بك.",
  "providerHints.myAcuriteCredentialsBanner": "استخدم البريد الإلكتروني وكلمة المرور لحساب My AcuRite — وليس تسجيل دخول SmartMixin.",
  "providerHints.myAcuriteEmail": "البريد الإلكتروني لحساب My AcuRite الخاص بك — وليس تسجيل دخولك إلى SmartMixin.",
  "providerHints.myAcuritePassword": "كلمة مرور حساب My AcuRite الخاص بك.",
  "providerHints.weatherflowToken": "رمز للاستخدام الشخصي من tempestwx.com → الإعدادات → تفويضات البيانات.",
  "providerHints.wundergroundEditKey": "استخدم مفتاحًا آخر",
  "providerHints.wundergroundKey": "سلسلة طويلة من صفحة مفاتيح API الخاصة بحساب Weather Underground الخاص بك — وليس كلمة مرور wunderground.com.",
  "providerHints.wundergroundKeyExample": "مثال: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "تم التحقق من مفتاح API",
  "providerHints.wundergroundKeyVerifying": "جارٍ التحقق من المفتاح…",
  "providerHints.wundergroundNoStationsNearby": "لم يتم العثور على محطات بالقرب من هذا الموقع. حاول إدخال معرف محطة مباشرة.",
  "providerHints.wundergroundStationId": "أي معرف محطة Weather Underground — معرفك أو محطة عامة بالقرب منك.",
  "providerHints.wundergroundStationIdExample": "مثال: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "احصل على مفتاح API الخاص بـ Ambient Weather.",
  "providerIntro.davisStep2": "احصل على مفتاح V2 API وسرّ API الخاص بـ Davis.",
  "providerIntro.ecowittStep2": "احصل على مفتاح API ومفتاح التطبيق Ecowitt.",
  "providerIntro.getStarted": "ابدأ",
  "providerIntro.myAcuriteStep2": "استخدم البريد الإلكتروني وكلمة المرور لحسابك الحالي على My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "سجّل الدخول إلى Netatmo عند الطلب — لا حاجة لمفتاح API.",
  "providerIntro.netatmoWeatherStep2": "سجّل الدخول إلى Netatmo عند الطلب — لا حاجة لمفتاح API.",
  "providerIntro.signupBanner": "أوشكت — أنشئ حساب SmartMixin مجاني لربط {provider}.",
  "providerIntro.step1": "سجّل الدخول إلى حسابك في SmartMixin (وليس إلى {provider}).",
  "providerIntro.step3EmailPassword": "أدخلها هنا.",
  "providerIntro.step3KeyOrToken": "ألصقه هنا.",
  "providerIntro.step3OAuth": "اعتمد SmartMixin في النافذة المنبثقة.",
  "providerIntro.step3Wunderground": "الصق مفتاح API الخاص بك، ثم اختر محطة قريبة أو أدخل أي معرف محطة.",
  "providerIntro.title": "ربط {provider}",
  "providerIntro.weatherflowStep2": "احصل على رمز Tempest للاستخدام الشخصي.",
  "providerIntro.wundergroundBrowsePublic": "ليس لديك محطة؟ تصفح المحطات العامة",
  "providerIntro.wundergroundFindNearby": "ابحث عن محطات قريبة",
  "providerIntro.wundergroundOrEnterId": "أو أدخل معرف محطة",
  "providerIntro.wundergroundStep2": "احصل على مفتاح API الخاص بك من Weather Underground. بعد ذلك يمكنك ربط أي محطة — محطتك أو محطة عامة.",
  "reports.agroMeteorology": "الأرصاد الجوية الزراعية",
  "reports.analysis": "التحليل",
  "reports.annualCumulativeRainfallComparison": "مقارنة هطول الأمطار التراكمي السنوي",
  "reports.annualHeatingDurationComparison": "مقارنة مدة التدفئة السنوية",
  "reports.annualHeatingEfficiency": "كفاءة التدفئة السنوية",
  "reports.annualIndoorComparison": "مقارنة البيئة الداخلية السنوية",
  "reports.annualIndoorReport": "تقرير البيئة الداخلية السنوي",
  "reports.annualOutdoorComparison": "مقارنة البيئة الخارجية السنوية",
  "reports.annualOutdoorReport": "تقرير البيئة الخارجية السنوي",
  "reports.annualReport": "التقرير السنوي",
  "reports.annualSolarReport": "تقرير الطاقة الشمسية السنوي",
  "reports.annualWaterBalance": "ميزان المياه السنوي",
  "reports.annualWaterBalanceCarryOver": "ترحيل السنة السابقة",
  "reports.annualWaterBalanceDescription": "يساعد ميزان المياه (النسخة المبسطة، يُستخدم فقط المطر والتبخر-النتح) في إدارة إمدادات المياه",
  "reports.avgHumidity": "متوسط الرطوبة",
  "reports.avgMaxTemperature": "متوسط درجة الحرارة العظمى",
  "reports.avgMetric": "المتوسط – {metric}",
  "reports.avgMinTemperature": "متوسط درجة الحرارة الصغرى",
  "reports.avgPressure": "متوسط الضغط الجوي",
  "reports.avgTemperature": "متوسط درجة الحرارة",
  "reports.comfortable": "مريحة (45% {lessThan} الرطوبة ≤ 60%)",
  "reports.cumulativeRainfall": "هطول الأمطار التراكمي",
  "reports.cumulativeRainfallDescription": "تتبع إجمالي هطول الأمطار المتراكم خلال الفترة المحددة.",
  "reports.dailyMaxRainfall": "أقصى هطول يومي",
  "reports.dataExport": "تصدير البيانات",
  "reports.dataExportXlsxFormatDescription": "تصدير جميع بيانات محطتك بتنسيق Excel (*.xlsx). بمجرد النقر على الزر، ستتلقى بريداً إلكترونياً بالبيانات المعالجة بعد بضع دقائق.",
  "reports.daysWithFrost": "أيام الصقيع",
  "reports.daysWithoutThaw": "أيام بدون ذوبان",
  "reports.daysWithStrongFrost": "أيام الصقيع الشديد",
  "reports.emailSent": "تم إرسال بريد إلكتروني إلى صندوق بريدك",
  "reports.grasslandTemperatureSum": "مجموع درجة حرارة المراعي",
  "reports.grasslandTemperatureSumDescription": "إذا تم تجاوز مجموع {threshold} في الربيع، فقد تم الوصول إلى بداية النمو المستدام (يعمل في أوروبا)",
  "reports.growingDegreeDays": "أيام الدرجات المتراكمة",
  "reports.highPressure": "ضغط مرتفع (متوسط الضغط ≥ 1013 مليبار)",
  "reports.indoorReport": "تقرير البيئة الداخلية",
  "reports.keyFacts": "الحقائق الرئيسية",
  "reports.longestRunOfRainyDays": "أطول فترة أيام ممطرة متتالية",
  "reports.longestRunWithoutRun": "أطول فترة بدون مطر",
  "reports.lowPressure": "ضغط منخفض (متوسط الضغط {lessThan} 1013 مليبار)",
  "reports.maxHumidity": "الرطوبة القصوى",
  "reports.maxMetric": "الحد الأقصى – {metric}",
  "reports.maxPressure": "الضغط الأقصى",
  "reports.maxPressureMagnitude24h": "أقصى تغير (/24 ساعة)",
  "reports.maxTemperature": "درجة الحرارة القصوى",
  "reports.maxTempGreaterThan": "درجة الحرارة العظمى ≥",
  "reports.maxTempMagnitude24h": "أقصى تغير (/24 ساعة)",
  "reports.minHumidity": "الرطوبة الدنيا",
  "reports.minMetric": "الحد الأدنى – {metric}",
  "reports.minPressure": "الضغط الأدنى",
  "reports.minPressureMagnitude24h": "أدنى تغير (/24 ساعة)",
  "reports.minTemperature": "درجة الحرارة الدنيا",
  "reports.minTempMagnitude24h": "أدنى تغير (/24 ساعة)",
  "reports.monthlyHeatingEfficiency": "كفاءة التدفئة الشهرية",
  "reports.monthlyIndoorReport": "تقرير البيئة الداخلية الشهري",
  "reports.monthlyOutdoorReport": "تقرير البيئة الخارجية الشهري",
  "reports.monthlyReport": "التقرير الشهري",
  "reports.monthlySolarReport": "تقرير الطاقة الشمسية الشهري",
  "reports.monthlyWindReport": "تقرير الرياح الشهري",
  "reports.numberOfDays": "عدد الأيام",
  "reports.outdoorReport": "تقرير البيئة الخارجية",
  "reports.rainfall": "هطول الأمطار",
  "reports.rainyDays": "الأيام الممطرة",
  "reports.relativelyWet": "رطبة نسبياً (60% {lessThan} الرطوبة ≤ 80%)",
  "reports.sendEmail": "إرسال بريد إلكتروني",
  "reports.tooDry": "جافة جداً (الرطوبة ≤ 45%)",
  "reports.tooWet": "رطبة جداً (الرطوبة {greaterThan} 80%)",
  "reports.tropicalNights": "الليالي الاستوائية",
  "reports.waterBalance": "ميزان المياه",
  "reports.yearToDateTemperature": "درجة الحرارة منذ بداية السنة",
  "reports.yearToDateTemperatureComparison": "مقارنة درجة الحرارة منذ بداية السنة",
  "sensors.aqiByChannel": "مؤشر جودة الهواء حسب القناة",
  "sensors.bgtSensors": "الكرة السوداء و WBGT",
  "sensors.cameraFeed": "الكاميرا",
  "sensors.compareAqi": "مقارنة مؤشر جودة الهواء",
  "sensors.compareHumidity": "مقارنة الرطوبة",
  "sensors.compareMoisture": "مقارنة الرطوبة الأرضية",
  "sensors.comparePm25": "مقارنة PM2.5",
  "sensors.compareTemperatures": "مقارنة درجات الحرارة",
  "sensors.depthByChannel": "العمق حسب القناة",
  "sensors.heatStressExtreme": "إجهاد حراري بالغ",
  "sensors.heatStressModerate": "إجهاد حراري معتدل",
  "sensors.heatStressNone": "لا إجهاد حراري",
  "sensors.heatStressStrong": "إجهاد حراري شديد",
  "sensors.heatStressVeryStrong": "إجهاد حراري شديد جدًا",
  "sensors.humidityByChannel": "الرطوبة حسب القناة",
  "sensors.indoorAirQuality": "جودة الهواء الداخلي",
  "sensors.indoorAirQualityPm": "PM2.5 و PM10 AQI",
  "sensors.indoorClimate": "المناخ الداخلي",
  "sensors.indoorCo2Levels": "مستويات CO2",
  "sensors.indoorTemperatureAndHumidity": "الحرارة والرطوبة",
  "sensors.last24Hours": "24 ساعة",
  "sensors.last30Days": "30 يوم",
  "sensors.last7Days": "7 أيام",
  "sensors.leafTemperatureByChannel": "حرارة الأوراق حسب القناة",
  "sensors.leafWetnessByChannel": "رطوبة الأوراق حسب القناة",
  "sensors.lightningSensor": "البرق",
  "sensors.moistureByChannel": "الرطوبة الأرضية حسب القناة",
  "sensors.noDataAvailable": "لا تتوفر بيانات",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 و AQI",
  "sensors.pm25ByChannel": "PM2.5 حسب القناة",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "اختر القناة",
  "sensors.sensorDetailDescription": "عرض البيانات التاريخية والاتجاهات لقنوات المستشعرات.",
  "sensors.sensorHistory": "سجل المستشعر",
  "sensors.soilConductivityByChannel": "التوصيلية حسب القناة",
  "sensors.soilTemperatureByChannel": "حرارة التربة حسب القناة",
  "sensors.strikesToday": "الضربات اليوم",
  "sensors.temperatureByChannel": "الحرارة حسب القناة",
  "sensors.viewChart": "عرض الرسم البياني",
  "settings.about": "حول",
  "settings.aboutDescription": "اتفاقية الترخيص، سياسة الخصوصية",
  "settings.account": "الحساب",
  "settings.accountDescription": "الملف الشخصي، تغيير كلمة المرور",
  "settings.accountIntro": "البيانات المتعلقة بحسابك:",
  "settings.accountSection": "الحساب",
  "settings.appearance": "المظهر",
  "settings.appearanceDescription": "السمة وخيارات العرض",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "العربية",
  "settings.availableServices": "متاحة",
  "settings.bulgarian": "البلغارية",
  "settings.cannotDisconnectLastAccount": "لا يمكن قطع الاتصال بطريقة تسجيل الدخول الوحيدة. يرجى إضافة طريقة تسجيل دخول أخرى أولاً.",
  "settings.catalan": "الكاتالانية",
  "settings.changeEmail": "تغيير البريد الإلكتروني",
  "settings.changePassword": "تغيير كلمة المرور",
  "settings.chartGestures": "الإيماءات على الرسوم البيانية",
  "settings.chartGesturesDescription": "السحب على الرسوم البيانية يغير الفترة الزمنية، والقرص يغير المقياس الزمني",
  "settings.connect": "اتصال",
  "settings.connected": "متصل",
  "settings.connectedAccounts": "الحسابات المتصلة",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "متصلة",
  "settings.connectedSince": "متصل منذ {date}",
  "settings.connectionSuccess": "تم الاتصال بحساب {provider} بنجاح",
  "settings.contactUs": "اتصل بنا",
  "settings.contactUsDescription": "احصل على المساعدة أو أرسل ملاحظاتك",
  "settings.croatian": "الكرواتية",
  "settings.currentPassword": "كلمة المرور الحالية",
  "settings.czech": "التشيكية",
  "settings.danish": "الدنماركية",
  "settings.dark": "المظهر الداكن",
  "settings.dataDisplay": "عرض البيانات",
  "settings.dateAndTime": "التاريخ والوقت",
  "settings.disconnect": "قطع الاتصال",
  "settings.disconnectConfirmation": "هل أنت متأكد من رغبتك في قطع الاتصال بحساب {provider} الخاص بك؟",
  "settings.disconnectionSuccess": "تم قطع الاتصال بحساب {provider} بنجاح",
  "settings.donateButton": "تبرّع",
  "settings.donateDescription": "تم بناء SmartMixin بواسطة فريق صغير. إذا وجدته مفيدًا، يمكنك دعم تطويره بتبرع لمرة واحدة بأي مبلغ. إنه هدية — فهو لا يغيّر باقتك ولا يفتح أي ميزات.",
  "settings.donateSuccessBody": "يساعد تبرعك في إبقاء SmartMixin يعمل ويتحسّن. نحن نقدّر ذلك حقًا.",
  "settings.donateSuccessTitle": "شكرًا لدعمك!",
  "settings.donateTitle": "ادعم SmartMixin",
  "settings.dutch": "الهولندية",
  "settings.emailChange": "تغيير عنوان البريد الإلكتروني",
  "settings.emailChangeConfirmation": "تأكيد تغيير البريد الإلكتروني",
  "settings.emailChangeFailure": "رابط تغيير البريد الإلكتروني غير صالح أو منتهي الصلاحية.",
  "settings.emailChangeSuccess": "تم تغيير بريدك الإلكتروني بنجاح إلى {newEmail}.",
  "settings.emailChangeVerificationSent": "تم إرسال بريد إلكتروني للتحقق إلى عنوان بريدك الإلكتروني الجديد. يرجى التحقق من صندوق الوارد والنقر على الرابط لتأكيد التغيير.",
  "settings.english": "الإنجليزية",
  "settings.forecastModelOrderEmpty": "لم يتم حفظ ترتيب — نستخدم GFS افتراضيًا.",
  "settings.forecastModelOrderFreeHint": "تتطلب النماذج المميزة اشتراك SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "نختار النموذج الأول من قائمتك الذي يغطي كل محطة.",
  "settings.forecastModelOrderReset": "إعادة الضبط",
  "settings.forecastModelOrderTitle": "نموذج التنبؤ الافتراضي",
  "settings.forecastModels": "نماذج التنبؤ",
  "settings.forecastModelsDescription": "إعادة الترتيب حسب التفضيل",
  "settings.french": "الفرنسية",
  "settings.german": "الألمانية",
  "settings.gestures": "الإيماءات",
  "settings.greek": "اليونانية",
  "settings.helpCenter": "مركز المساعدة",
  "settings.helpCenterDescription": "الأسئلة الشائعة والأدلة",
  "settings.hungarian": "المجرية",
  "settings.integrationsSection": "التكاملات",
  "settings.italian": "الإيطالية",
  "settings.japanese": "اليابانية",
  "settings.korean": "الكورية",
  "settings.language": "اللغة",
  "settings.languageDescription": "اللغة المفضلة",
  "settings.light": "المظهر الفاتح",
  "settings.newEmailAddress": "عنوان البريد الإلكتروني الجديد",
  "settings.newPassword": "كلمة المرور الجديدة",
  "settings.newPasswordAgain": "كلمة المرور الجديدة مرة أخرى",
  "settings.norwegian": "النرويجية",
  "settings.notConnected": "غير متصل",
  "settings.notificationsSection": "الإشعارات",
  "settings.oldPassword": "كلمة المرور القديمة",
  "settings.ongoingNotificationEnabled": "تفعيل الإشعار الدائم",
  "settings.ongoingNotificationMetrics": "القياسات المعروضة",
  "settings.ongoingNotificationMetricsHint": "اسحب لإعادة ترتيب المقاييس المحددة",
  "settings.ongoingNotificationPermissionRequired": "إذن الإشعارات مطلوب",
  "settings.ongoingNotificationStation": "محطة الطقس",
  "settings.passwordChange": "تغيير كلمة المرور",
  "settings.polish": "البولندية",
  "settings.portuguese": "البرتغالية",
  "settings.preferencesSection": "التفضيلات",
  "settings.premium": "المميز",
  "settings.premiumActive": "نشط",
  "settings.premiumAnnualThenPrice": "ثم 9.99 €/سنة",
  "settings.premiumAnnualTrialInfo": "ابدأ بفترة تجريبية مجانية لمدة {days} يوم",
  "settings.premiumCurrentPlan": "الباقة الحالية",
  "settings.premiumDescription": "إدارة اشتراكك",
  "settings.premiumDownloadApp": "نزّل التطبيق للاشتراك:",
  "settings.premiumExpiresOn": "يتجدد في {date}",
  "settings.premiumFreePlan": "مجانية",
  "settings.premiumInactive": "غير مشترك",
  "settings.premiumManageWebSubscription": "إدارة اشتراكك، تحديث طريقة الدفع، أو الإلغاء.",
  "settings.premiumPremiumPlan": "المميزة",
  "settings.premiumSubscribeAnnual": "سنوي — 9,99 €/سنة",
  "settings.premiumSubscribedOn": "مُشترك عبر {platform}",
  "settings.premiumSubscribeMonthly": "شهري — 1,99 €/شهر",
  "settings.premiumSubscribeOnWeb": "اشترك الآن لفتح جميع الميزات المميزة.",
  "settings.premiumSubscriptionSuccess": "تم تفعيل اشتراكك! استمتع بجميع الميزات المميزة.",
  "settings.premiumSubscriptionSuccessTitle": "مرحبًا في Premium!",
  "settings.premiumWebappNotice": "لا يمكن شراء الاشتراكات إلا من خلال تطبيق SmartMixin للجوال على iOS أو Android.",
  "settings.privacyPolicy": "سياسة الخصوصية",
  "settings.profile": "الملف الشخصي",
  "settings.russian": "الروسية",
  "settings.serbian": "الصربية",
  "settings.settings": "الإعدادات",
  "settings.slovak": "السلوفاكية",
  "settings.smallDecimals": "أرقام عشرية صغيرة",
  "settings.smallDecimalsDescription": "عرض الأرقام العشرية بحجم أصغر",
  "settings.socialConnectionsIntro": "اربط حساباتك الاجتماعية لتمكين تسجيل الدخول السريع. يمكنك ربط الحسابات أو إلغاء ربطها في أي وقت.",
  "settings.spanish": "الإسبانية",
  "settings.statusBarWidget": "أداة شريط الحالة",
  "settings.statusBarWidgetDescription": "بيانات الطقس مرئية دائمًا",
  "settings.subscriptionSection": "الاشتراك",
  "settings.supportSection": "الدعم",
  "settings.swedish": "السويدية",
  "settings.systemTheme": "مظهر النظام",
  "settings.termsOfService": "شروط الخدمة",
  "settings.turkish": "التركية",
  "settings.ukrainian": "الأوكرانية",
  "settings.units": "الوحدات",
  "settings.unitsDescription": "وحدات القياس المعروضة داخل التطبيق",
  "settings.update": "تحديث",
  "settings.updateYourProfile": "تحديث ملفك الشخصي",
  "settings.weatherServices": "خدمات الطقس",
  "settings.weatherServicesConnected": "{count, plural, =0 {لا توجد خدمات متصلة} one {# خدمة متصلة} two {# خدمتان متصلتان} few {# خدمات متصلة} many {# خدمة متصلة} other {# خدمة متصلة}}",
  "settings.weatherServicesDescription": "اربط Netatmo وDavis وWeatherflow والمزيد",
  "settings.windDirectionConvention": "سهم اتجاه الرياح",
  "settings.windDirectionConventionDescription": "اختر كيفية عرض أسهم اتجاه الرياح",
  "settings.windDirectionMeteorological": "اتجاه المصدر",
  "settings.windDirectionMeteorologicalDescription": "يشير السهم إلى مصدر الرياح (الاصطلاح الأرصادي)",
  "settings.windDirectionOceanographic": "اتجاه التدفق",
  "settings.windDirectionOceanographicDescription": "يشير السهم إلى وجهة الرياح (الاصطلاح المحيطي)",
  "units.absolutePressure": "الضغط المطلق",
  "units.airDensity": "كثافة الهواء",
  "units.airGap": "الفجوة الهوائية",
  "units.apparentTemperature": "درجة الحرارة الظاهرية",
  "units.AQI": "مؤشر جودة الهواء",
  "units.AQI_24H": "24h AQI",
  "units.avg": "متوسط",
  "units.beaufort": "بوفورت",
  "units.blackGlobeTemperature": "حرارة الكرة السوداء",
  "units.boilerOn": "المرجل يعمل",
  "units.co2": "ثاني أكسيد الكربون",
  "units.conductivity": "التوصيلية",
  "units.coolingDegreeDays": "أيام درجة التبريد",
  "units.dailyHeatingDuration": "مدة التدفئة اليومية",
  "units.dailyPrecipitation": "هطول الأمطار اليومي",
  "units.dailyRain": "المطر اليومي",
  "units.degreeDay": "يوم درجة",
  "units.degreeDayShort": "ي.د",
  "units.depth": "العمق",
  "units.depthSensors": "مستشعرات العمق",
  "units.dewPoint": "نقطة الندى",
  "units.distance": "المسافة",
  "units.downTrend": "هبوط",
  "units.E": "ق",
  "units.E_long": "شرق",
  "units.ENE": "ق ش ق",
  "units.ENE_long": "شرق-شمال شرقي",
  "units.ESE": "ق ج ق",
  "units.ESE_long": "شرق-جنوب شرقي",
  "units.ET": "التبخر-النتح",
  "units.ETshort": "ت-ن",
  "units.feelLike": "الإحساس الحراري",
  "units.feelsLike": "الإحساس الحراري",
  "units.footMile": "قدم، ميل",
  "units.frostPoint": "نقطة الصقيع",
  "units.gust": "هبة",
  "units.heatIndex": "مؤشر الحرارة",
  "units.heatingDegreeDays": "أيام درجة التدفئة",
  "units.heatingPower": "قوة التدفئة",
  "units.humidex": "مؤشر الرطوبة",
  "units.humidity": "الرطوبة",
  "units.inch": "بوصة",
  "units.inchOfMercury": "بوصة زئبق",
  "units.kilometerPerHour": "كيلومتر في الساعة",
  "units.knot": "عقدة",
  "units.last12Hours": "آخر 12 ساعة",
  "units.last24Hours": "آخر 24 ساعة",
  "units.last3Hours": "آخر 3 ساعات",
  "units.last6Hours": "آخر 6 ساعات",
  "units.lastHour": "الساعة الأخيرة",
  "units.lastLightningImpact": "آخر تأثير",
  "units.lastMeasure": "آخر قياس",
  "units.leafSensors": "مستشعرات الأوراق",
  "units.leafWetness": "رطوبة الأوراق",
  "units.lightningDistance": "المسافة",
  "units.lightningStrikeCount": "عدد ضربات البرق",
  "units.lightningStrikeDistance": "مسافة ضربة البرق",
  "units.max": "أقصى",
  "units.max_gust": "أقصى هبة",
  "units.max_wind": "أقصى رياح",
  "units.meterKilometer": "متر، كيلومتر",
  "units.meterPerSecond": "متر في الثانية",
  "units.milePerHour": "ميل في الساعة",
  "units.millibar": "مليبار",
  "units.millimeter": "مليمتر",
  "units.millimeterOfMercury": "مليمتر زئبق",
  "units.min": "أدنى",
  "units.N": "ش",
  "units.N_long": "شمال",
  "units.NE": "ش ق",
  "units.NE_long": "شمال شرقي",
  "units.NNE": "ش ش ق",
  "units.NNE_long": "شمال-شمال شرقي",
  "units.NNW": "ش ش غ",
  "units.NNW_long": "شمال-شمال غربي",
  "units.noise": "الضوضاء",
  "units.normalizedHeatingCoefficient": "معامل التدفئة المعياري",
  "units.NW": "ش غ",
  "units.NW_long": "شمال غربي",
  "units.O3": "الأوزون",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "الهطول",
  "units.pressure": "الضغط الجوي",
  "units.rain": "المطر",
  "units.rainRate": "معدل هطول المطر",
  "units.referenceTemperature": "درجة الحرارة المرجعية",
  "units.relativePressure": "الضغط النسبي",
  "units.S": "ج",
  "units.S_long": "جنوب",
  "units.SE": "ج ق",
  "units.SE_long": "جنوب شرقي",
  "units.setPoint": "نقطة الضبط",
  "units.snow": "ثلج",
  "units.snowfall": "تساقط الثلوج",
  "units.soilMoisture": "رطوبة التربة",
  "units.soilSensors": "مستشعرات التربة",
  "units.solarEnergy": "الطاقة الشمسية",
  "units.solarRadiation": "الإشعاع الشمسي",
  "units.speed": "السرعة",
  "units.SSE": "ج ج ق",
  "units.SSE_long": "جنوب-جنوب شرقي",
  "units.SSW": "ج ج غ",
  "units.SSW_long": "جنوب-جنوب غربي",
  "units.stableTrend": "مستقر",
  "units.sum": "المجموع",
  "units.SW": "ج غ",
  "units.SW_long": "جنوب غربي",
  "units.temperature": "درجة الحرارة",
  "units.temperatureAndHumiditySensors": "مستشعرات الحرارة والرطوبة",
  "units.temperatureSensors": "مستشعرات الحرارة والرطوبة",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "اليوم",
  "units.upTrend": "صعود",
  "units.uv": "الأشعة فوق البنفسجية",
  "units.visibility": "الرؤية",
  "units.W": "غ",
  "units.W_long": "غرب",
  "units.wetBulbGlobeTemperature": "حرارة البصيلة الرطبة الكروية",
  "units.wetBulbTemperature": "حرارة البصيلة الرطبة",
  "units.wind": "الرياح",
  "units.windChill": "برودة الرياح",
  "units.windDirection": "اتجاه الرياح",
  "units.windRun": "مسافة الرياح",
  "units.windRunDescription": "مسافة الرياح هي المسافة الإجمالية التي قطعتها الرياح خلال فترة زمنية",
  "units.WNW": "غ ش غ",
  "units.WNW_long": "غرب-شمال غربي",
  "units.WSW": "غ ج غ",
  "units.WSW_long": "غرب-جنوب غربي"
}
